import { render, staticRenderFns } from "./SellModify.vue?vue&type=template&id=b70c3e74&"
import script from "./SellModify.vue?vue&type=script&lang=js&"
export * from "./SellModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports